import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

import { useUtils } from '@core/libs/i18n'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useDriversList() {
  // Use toast
  const toast = useToast()

  const { t } = useUtils()

  const refDriverListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'name', sortable: false, label: t('Name') },
    { key: 'owner', sortable: true, label: t('Owner Name')},
    { key: 'phone', sortable: true,label:t('phone number') },
    { key: 'devices', sortable: true,label:t('devices') },

    { key: 'actions' ,label:t('actions')},
  ]

  const perPage = ref(10)
  const totalDrivers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const ownerFilter = ref(null)

  const requestStatus = ref(false)

  const dataMeta = computed(() => {
    const localItemsCount = refDriverListTable.value ? refDriverListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalDrivers.value,
    }
  })

  const refetchData = () => {
    refDriverListTable.value.refresh()
  }

  const filter = ref({})

  watch([currentPage, perPage, searchQuery, ownerFilter ], () => {

    filter.value = {
      ...(ownerFilter.value && {owner: ownerFilter.value}),
      ...(searchQuery.value && {q: searchQuery.value})
    }

    refetchData()
  })

  const fetchDrivers = (ctx, callback) => {

    requestStatus.value = true

    store
      .dispatch('app_driver/fetchDrivers', {
        length: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        ...filter.value
        // sortDesc: isSortDirDesc.value,
      })
      .then(response => {
        requestStatus.value = false
        const { data } = response.data.data
        const {total} =response.data.data.meta
      
        callback(data)
        totalDrivers.value = total
      })
      .catch(() => {
        requestStatus.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching drivers list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*



  return {

    fetchDrivers,
    tableColumns,
    perPage,
    currentPage,
    totalDrivers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDriverListTable,
    ownerFilter,

    requestStatus,
    refetchData,

  }
}
